// extracted by mini-css-extract-plugin
export var btnLink = "BtnLink-module--btn-link--1uPBj";
export var btnLinkWhite = "BtnLink-module--btn-link-white--2C1GC";
export var btnLinkSecondary = "BtnLink-module--btn-link-secondary--1Galc";